import {Injectable} from '@angular/core';
import {Router, RoutesRecognized} from '@angular/router';
import {filter, pairwise, tap} from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class PreviousRouteService {
    previousRoute$ = this.router.events.pipe(
        filter((evt: any) => evt instanceof RoutesRecognized),
        pairwise(),
        tap((x) => (this.previousUrl = x[0].urlAfterRedirects))
    );
    private previousUrl: string;
    constructor(private router: Router) {}

    getPreviousUrl() {
        return this.previousUrl;
    }
}
